export const images = [{
    img: require('./leds.jpg'),
    nombre: 'Iluminacion',
    url:'productsLigths'}, 
    {img: require('./fotografia.jpg'),
    nombre:'Camaras y Lentes',
    url:'productsPhoto'}, 
    {img: require('./Microfono.jpg'),
    nombre:'Sonido',
    url:'productsSound'},
]